const phoneNumbers = {
  INTERNATIONAL: '+31 (0)79 808 01 33',
  NL: '+31 (0)79 808 01 33',
  DE: '+49 (0)75 199 723 048',
  BE: '+32 (0)25 885 737',
  AT: '+49 (0)75 199 723 048',
  GB: '+44 (0)13 16 08 02 78',
  CH: '+49 (0)75 199 723 048',
};

type ContactSalesCountry = keyof typeof phoneNumbers;

const isContactSalesCountry = (country: string | undefined): country is ContactSalesCountry =>
  country !== undefined && Object.hasOwn(phoneNumbers, country);

export class ContactSales {
  enterpriseEmail = 'enterprise@shiftbase.com';

  private country: string | undefined;

  constructor(country: string | undefined) {
    this.country = country;
  }

  get phoneNumber(): string {
    return isContactSalesCountry(this.country) ? phoneNumbers[this.country] : phoneNumbers.INTERNATIONAL;
  }
}
